var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chargingTime"},[_c('title1',{attrs:{"type":"1","title":"充电时间尖峰平谷占比","subTitle":"Electric Port Overview"}}),_c('div',{ref:"pieone",staticClass:"pieon",attrs:{"id":"pieon"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }